module.exports = __webpack_public_path__ + "img/04_04.2e581ffe.gif";